const breakPoint = {
  mb: 1200,
}

export { breakPoint }